import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getCentersList(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get('Centers/ListCenters', {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}